/**
 * Profile / stats workout completion gate aligned with backend
 * EFFECTIVE_FULL_COMPLETION_THRESHOLD (80) and legacy completePercentage === 100.
 */
export const EFFECTIVE_FULL_COMPLETION_THRESHOLD = 80;

export function isEffectivelyCompletedWorkout(event: {
  endDate?: string | Date | null;
  completePercentage?: number | null;
  rewardCompletionPercentage?: number | null;
}): boolean {
  if (!event.endDate) return false;
  const reward = event.rewardCompletionPercentage;
  if (reward !== null && reward !== undefined && Number.isFinite(reward)) {
    return reward >= EFFECTIVE_FULL_COMPLETION_THRESHOLD;
  }
  return event.completePercentage === 100;
}
